// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__23LLo","label":"Radio_label__cbehr","checkMark":"Radio_checkMark__1Yzng","disabled":"Radio_disabled__PQHQC"};